import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { MenuPosition } from '../../typings/menu';
import { StyledMenuItem, StyledMenuItemLink } from '../MenuManager/Left/MenuItem/styles';
import { getMenuButtonIcon } from '../../utils/menuManager';
import { StyledHeaderButton } from '../MenuManager/Header/HeaderButton/styles';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import Tooltip from '../Tooltip';
import { resumeLastPublication } from '../../containers/BackToPublication/actions';

interface BackToPublicationProps {
	publicationId: number;
	page: number | undefined;
	position: MenuPosition;
	iconSrc: string;
	icon?: string;
	label?: string;
	dispatch: Dispatch<StoreState>;
}

const BackToPublication = ({
	publicationId,
	page,
	position,
	iconSrc,
	label,
	dispatch,
}: BackToPublicationProps) => {
	if (position === MenuPosition.burger) {
		return (
			<StyledMenuItem
				className="BackToPublication menu-item back_btn"
				onClick={() => dispatch(resumeLastPublication(publicationId, page))}
			>
				<StyledMenuItemLink>
					{getMenuButtonIcon(iconSrc, 'iconset_back_to_publication-bold')}
					{label || <Translate value="messages.resuming" />}
				</StyledMenuItemLink>
			</StyledMenuItem>
		);
	}

	const tooltipId = Utils.generateId();
	return (
		<StyledHeaderButton
			className="BackToPublication"
			type="button"
			data-tip={true}
			data-for={tooltipId}
			onClick={() => dispatch(resumeLastPublication(publicationId, page))}
		>
			{getMenuButtonIcon(iconSrc, 'iconset_back_to_publication')}
			{UserAgentUtils.isDesktop() &&
				<Tooltip id={tooltipId} text={label || 'messages.resuming'} />
			}
		</StyledHeaderButton>
	);
};

export default BackToPublication;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/BackToPublication/index.tsx